// Completion errors may be DRF field dictionaries, arrays, or Axios responses.
function collectMessages(value) {
  if (typeof value === 'string') {
    const text = value.trim();
    return !text || text.startsWith('<') ? [] : [text];
  }
  if (Array.isArray(value)) return value.flatMap(collectMessages);
  if (!value || typeof value !== 'object') return [];
  for (const key of ['message', 'detail', 'error']) {
    if (value[key]) return collectMessages(value[key]);
  }
  if (value.errors) return collectMessages(value.errors);
  return Object.entries(value)
    .filter(([key]) => !['status', 'state', 'code', 'ok', 'first_error_field'].includes(key))
    .flatMap(([, item]) => collectMessages(item));
}

export function drawingSubmissionError(result) {
  const payload = result?.response?.data ?? result?.data ?? result;
  if (result?.response || !result?.isAxiosError) {
    const messages = [...new Set(collectMessages(payload))];
    if (messages.length) return messages.join(' ');
  }
  const status = Number(result?.response?.status || result?.status);
  if (status === 401) return 'Сессия истекла. Войдите снова и откройте карточку события.';
  if (status === 403) return 'Сдача чертежа недоступна для этого пользователя. Обновите карточку и проверьте назначение чертёжника у менеджера.';
  if (status === 409) return 'Событие или его файлы изменились. Обновите карточку и проверьте материалы перед повторной сдачей.';
  if (status >= 500) return `Сервер не подтвердил сдачу чертежа (HTTP ${status}). Обновите карточку и проверьте статус работы перед повторной отправкой. Если ошибка повторится, сообщите менеджеру номер сделки и этот код.`;
  if (result?.code === 'ECONNABORTED' || result?.code === 'ERR_NETWORK') {
    return 'Ответ сервера не получен. Обновите карточку и проверьте, сдан ли чертёж, перед повторной отправкой.';
  }
  return 'Не удалось сдать чертёж. Обновите карточку; если ошибка повторится, сообщите менеджеру номер сделки.';
}

export function validDrawingSquare(value) {
  if (typeof value === 'boolean') return false;
  const square = Number(value);
  return Number.isInteger(square) && square > 0 && square <= 10000000;
}

// Mirrors the existing completion guards so a disabled button explains what
// needs to change, without bypassing server permissions or workflow checks.
export function drawingCompletionBlockReason(item, mediaBusy = false) {
  if (item?.is_additional_measuring) return 'Сначала обмерщик должен завершить дополнительный обмер.';
  if (item?.state !== 'drawing') return 'Завершение доступно на стадии «Черчение». Обновите карточку или уточните стадию у менеджера.';
  if (item?.quality?.state === 'pending') return 'Чертёж уже отправлен на контроль качества.';
  if (item?.quality?.state === 'passed') return 'Контроль качества уже пройден. Повторная сдача сейчас не требуется.';
  if (!item?.media_access?.drawings_write) return 'Рабочие чертежи сейчас недоступны для изменения. Обновите карточку; если вы назначены чертёжником, сообщите менеджеру номер сделки.';
  if (mediaBusy) return 'Дождитесь загрузки списка файлов и завершения всех загрузок. При ошибке откройте «Рабочие чертежи» и повторите загрузку списка.';
  return '';
}
